import React, { Component } from 'react';
import { Card, Modal, Badge } from "react-bootstrap";
import { FaPen, FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from "react-icons/fa6";
import { GetText, ReplacePrefixUrl, ReplaceText, RemoveHtmlTag } from '../../config/helper';
import DateTimeFormats from '../../config/date-time-format';
import DiscussionForm from './Form';
// import PromptDetail from './Detail';
// import NAimage from '../../img/pic-na.png';

const authKey = global.config.kindcode.training[23]+global.config.authBearerKey;

export default class Block extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      currPage: '',
      activePage: '',
      id: '',
      title: '',
      categoryid: '', 
      category: '',
      excerpt: '',
      status: '',
      createbyid: '',
      createby: '',
      createon: '',
      lastupdate: '',
      data: {},
      modal_show_form: false,
      // modal_show_detail: false,
      // memberStatus: localStorage.getItem('status')
    }
  }
  handlePopOpen(name) {
    this.setState({ 
      [name]: true,
    });
  }
  handlePopClose(name) {
    this.setState({ 
      [name]: false,
    });
  }
  handleOpenPage(url) {
    window.location.href=url;
  }
  
  
  componentDidMount() {
    var content = this.props.value;
    console.log("Block");
    console.log(content);
    var threadData = content.data;
    this.setState({
      currPage: content.currpage,
      activePage: threadData.activePage,
      id: threadData.id,
      // image: (content.libraryPicture !== "" && content.libraryPicture !== undefined)? content.libraryPicture : NAimage,
      title: ReplaceText(threadData.threadTitle),
      categoryid: threadData.threadCategoryId, 
      category: threadData.threadCategoryName,
      excerpt: RemoveHtmlTag(threadData.threadDescription),
      status: threadData.threadStatus,
      createbyid: threadData.createById,
      createby: threadData.createByName,
      createon: threadData.createDate !== undefined? DateTimeFormats(threadData.createDate._seconds,"datetime-short") : '',
      lastupdate: threadData.lastUpdate !== undefined? DateTimeFormats(threadData.lastUpdate._seconds,"datetime-short") : '',
      // link: '/library/' + ReplacePrefixUrl(content.libraryTitle) + '/' + content.id
      // link: '/library/' + ReplaceAllContent(" ", "-", content.libraryTitle).replace(/[^0-9a-zA-Z-]/g, '').substring(0,50) + '/' + content.id
      // link: (this.state.memberStatus === 'Member' ? '/enroll/' : '/library/') + content.id,
      data: threadData,
    });
  }
  
  render() {   
    return (
      <div className="w-100">
        <div className="discussion-block text-link" onClick={this.handleOpenPage.bind(this,global.config.urlHost+this.state.currPage+"/"+this.state.id)}>
          <Badge pill bg="secondary" className="px-2 py-1 mb-2">{this.state.category}</Badge>
          <h6>{this.state.title}</h6>
          <p>{this.state.excerpt.substring(0,250)} {this.state.excerpt.length > 250 && "..."}</p>
          <div className="row">
            <div className='col-4'>

            </div>
            <div className='col-8 d-flex justify-content-end text-end'>
                {GetText() ? "dibuat oleh" : "created by"} {this.state.createby} <br/>
                {GetText() ? "terakhir dibalas" : "latest update"} {this.state.lastupdate}
            </div>
            
          </div>
        </div>
				{/* <Card className="discussion-block">
					<Card.Body onClick={this.handleOpenPage.bind(this,global.config.urlHost+this.state.currPage+"/"+this.state.id)} className='text-link' >
						<Card.Title>{this.state.title}</Card.Title>
						<Card.Text>
							{this.state.excerpt}
						</Card.Text>
					</Card.Body>
          <Card.Footer className="text-muted">
            {this.contentLikeIcons(this.state.likestatus,this.state.like,this.state.dislike,this.state.createbyid,this.state.memberId,this.state.id,this.state.likestatusid,this.state.likestatususer)}
          </Card.Footer>
				</Card> */}

        <Modal animation={false} show={this.state.modal_show_form} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_form")}>
          <Modal.Header closeButton>
            <Modal.Title>{GetText() ? "Edit topik Anda" : "Edit your topic"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DiscussionForm value={{"currpage": this.state.activePage, "data": this.state.data}} />
          </Modal.Body>
        </Modal>

        {/* <Modal animation={false} show={this.state.modal_show_detail} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_detail")}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <PromptDetail value={{"currpage": this.state.activePage, "data": this.state.data, "type": "block"}} />
          </Modal.Body>
        </Modal> */}
			</div>
      
      
    )
  }
}